import { Link } from "react-router-dom";
import ChevronIcon from "svg-icons/chevron-icon";
import "./../data.scss";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { useSelector } from "react-redux";

function CardData({
  title,
  id,
  color,
  imgCard,
  subSubjects,
  subjectTranslations,
}) {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <div className="col-12">
      <div className="title-item">
        <h4 style={{ color: color }}>
          <LabelLang
            id="title"
            defaultValue={title}
            translations={subjectTranslations}
          />
        </h4>
      </div>
      <div className="row gx-0 gx-md-3 gy-lg-0 gy-4 d-flex justify-content-md-start justify-content-center">
        <div
          className="col-lg-3 col-11"
          style={{ borderInlineEnd: `5px solid ${color}` }}
        >
          <div className="img-data">
            <img src={imgCard} alt="img-Data" />
          </div>
        </div>
        <div className="col-lg-9 col-11">
          <div className="row gx-0 gx-md-3 gy-md-0 gy-2 d-flex align-items-center">
            {subSubjects.map((item, i) => (
              <div key={i} className="col-xxl-4 col-md-6 ">
                <div className="links-list">
                  <Link to={`mainSubject/${id}/subSubject/${item?.id}`}>
                    <ChevronIcon width={20} height={12} color={`${color}`} />
                    <span>
                      {LabelLangString({
                        id: "title",
                        currentLocale: currentLocale,
                        defaultValue: item?.title,
                        translations: item?.subjectTranslations,
                      })}
                    </span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardData;
